import { business } from "../data/siteData";

function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-heading">
          <p className="eyebrow">Get In Touch</p>
          <h2>Request Your Free Quote</h2>
          <p className="section-subtext">
            Give us a call or send us an email — we'd love to help with your curtains and
            blinds.
          </p>
        </div>

        <dl className="contact__details">
          <div>
            <dt>Phone</dt>
            <dd>
              <a href={`tel:${business.phone.replace(/\s/g, "")}`}>{business.phone}</a>
            </dd>
          </div>
          <div>
            <dt>Email</dt>
            <dd>
              <a href={`mailto:${business.email}`}>{business.email}</a>
            </dd>
          </div>
          <div>
            <dt>Address</dt>
            <dd>{business.address}</dd>
          </div>
          <div>
            <dt>Hours</dt>
            <dd>{business.hours}</dd>
          </div>
        </dl>
      </div>
    </section>
  );
}

export default Contact;
